import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { ITablesTreeListResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS,
  TABLES_TREE_LIST_QUERY_KEY,
  TABLES_TREE_LIST_URL,
} from '../constants';

export default function useTablesTreeListQuery(): IContextQueryResult<ITablesTreeListResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ITablesTreeListResponse>({
    queryKey: [TABLES_TREE_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(TABLES_TREE_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW,
    }),
    placeholderData: keepPreviousData,
  });
}
